'use client';
import { DialogDescription } from '@radix-ui/react-dialog';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';

const OrderTotalMismatchModal = ({ open, setOpen, setProceedFurther }: any) => {
  return (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-[690px] bg-white sm:rounded-md">
          <DialogHeader>
            {/* chng-text-25px */}
            <DialogTitle className="text-2xl font-bold">Order Total Mismatch</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            Are you sure you want to proceed to the review step with the payment amount and order total out of balance?
          </DialogDescription>
          <section className="mt-4 flex justify-start gap-4">
            <Button
              className="text-blueLight underline"
              onClick={() => {
                setOpen(false);
                setProceedFurther(false);
              }}
            >
              No, Edit Payment Amount
            </Button>
            <Button
              className="rounded-md bg-deepBlue p-4 text-white"
              onClick={() => {
                setProceedFurther(true);
                setOpen(false);
              }}
            >
              Yes, Proceed to Review
            </Button>
            <Button
              className="p-0 underline"
              onClick={() => {
                setOpen(false);
                setProceedFurther(false);
              }}
            >
              Cancel
            </Button>
          </section>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OrderTotalMismatchModal;
